import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

interface FaroInitOptions {
  url: string;
  appName: string;
  appVersion: string;
  environment: string;
}

export function initFaro(options: FaroInitOptions): void {
  initializeFaro({
    url: options.url,
    app: {
      name: options.appName,
      version: options.appVersion,
      environment: options.environment,
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
    ],
  });
}
